import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import axios from '../../../utils/axiosConfig';

const ModalRoles = ({ idEditRole, onClose, data }) => {
    const [nombre, setNombre] = useState('');
    const saveRole = async () => {
        console.log('Guardando rol:', nombre);
        if (idEditRole !== -1) {
            // Lógica para editar el rol
            if (nombre.trim() === '') {
                Swal.fire('Error', 'El nombre del rol no puede estar vacío', 'error');
                return;
            }
            let dataUpdate = {
                IDRol: idEditRole,
                NombreRol: nombre
            }
            console.log('Datos a actualizar:', dataUpdate);
            axios.post(process.env.REACT_APP_SERVER + '/usuarios/crearrolusuario', JSON.stringify(dataUpdate), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('tkn')}`
                },
                withCredentials: true
            }).then(res => {
                console.log('Rol actualizado:', res.data);
                Swal.fire('Éxito', 'El rol ha sido actualizado exitosamente', 'success');
                onClose();
            }).catch(error => {
                console.error('Error al guardar rol:', error);
            });
        } else {
            // Lógica para crear un nuevo rol
            if (nombre.trim() === '') {
                Swal.fire('Error', 'El nombre del rol no puede estar vacío', 'error');
                return;
            }
            let dataCreate = {
                IDRol: -1,
                NombreRol: nombre

            }

            console.log('Creando rol con datos:', dataCreate);
            axios.post(process.env.REACT_APP_SERVER + '/usuarios/crearrolusuario', JSON.stringify(dataCreate), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('tkn')}`
                },
                withCredentials: true
            }).then(res => {
                console.log('Rol creado:', res.data);
                Swal.fire('Éxito', 'El rol ha sido creado exitosamente', 'success');
                onClose();
            }).catch(error => {
                console.error('Error al guardar rol:', error);
            });
        }
    }

    useEffect(() => {
        if (idEditRole) {
            console.log('Editando rol:', idEditRole);
        }
    }, [idEditRole]);

    useEffect(() => {
        if (data) {
            console.log('Datos del rol a editar:', data);
            setNombre(data.NombreRol || '');
        }
    }, [data]);
    return (
        <>
            <MDBRow className="mb-3 g-0">
                <MDBCol size="12">
                    <label className="form-label">Nombre del rol</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Nombre de el rol"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        autoFocus
                        style={{ boxSizing: 'border-box' }}
                    />
                </MDBCol>
            </MDBRow>

            <div className="flex justify-end mb-2">
                <button
                    className="btn-primary-modals-permisos-roles"
                    onClick={() => saveRole()}
                >
                    {idEditRole !== -1 ? 'Actualizar' : 'Guardar'}
                </button>
            </div>
        </>
    )
}

export default ModalRoles


